/**
 * RemovedOverlay - the full-screen terminal state after a host removes this
 * participant. React port of showRemovedOverlay; once shown it never clears
 * (parity: the imperative overlay had no dismiss path - the tab is done).
 */
import { useStore } from 'zustand';
import { Ban } from 'lucide';
import { hudStore } from '../../state/hudStore';
import { Icon } from './Icon';
import type { LucideIconNode } from '../../utils/iconCanvas';

export function RemovedOverlay() {
  const shown = useStore(hudStore, (s) => s.removedOverlay);
  if (!shown) return null;

  return (
    <div
      id="removed-overlay"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(10,10,14,0.96)',
        zIndex: 20000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'sans-serif',
        color: '#fff',
        textAlign: 'center',
        padding: '24px',
      }}
    >
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}>
        <Icon icon={Ban as unknown as LucideIconNode} size={44} />
      </div>
      <h2 style={{ margin: '0 0 10px', fontSize: '24px' }}>You were removed from this session</h2>
      <p style={{ margin: 0, color: '#bbb', fontSize: '15px', maxWidth: '420px' }}>
        The host has removed you from the meeting. If you believe this was a mistake, contact the
        host for a new invite link.
      </p>
    </div>
  );
}
